import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DashboardLayout from "@/layouts/DashboardLayout";
import ProfessionalHome from "@/pages/professional/Home";
import ProfessionalApplications from "@/pages/professional/Applications";
import ProfessionalProfile from "@/pages/professional/Profile";
import ProfessionalSaved from "@/pages/professional/Saved";
import FacilityHome from "@/pages/facility/Home";
import FacilityJobs from "@/pages/facility/Jobs";
import FacilityApplications from "@/pages/facility/Applications";
import FacilityProfile from "@/pages/facility/Profile";
import FacilitySearch from "@/pages/facility/Search";
import FacilityStats from "@/pages/facility/Stats";
import Chat from "@/pages/Chat";
import Calendar from "@/pages/Calendar";
import AdminHome from "@/pages/admin/Home";
import AdminVerifications from "@/pages/admin/Verifications";
import JobDetail from "@/pages/JobDetail";

function Protected({ children, roles }) {
    const { user, ready } = useAuth();
    const location = useLocation();
    if (!ready) return <div className="p-10 text-sm text-muted-foreground">Caricamento…</div>;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (roles && !roles.includes(user.role))
        return <Navigate to="/app" replace />;
    return children;
}

function AppRouter() {
    const { user } = useAuth();
    const homeFor = (u) => {
        if (!u) return "/login";
        if (u.role === "professional") return "/app/opportunita";
        if (u.role === "facility") return "/app/annunci";
        if (u.role === "admin") return "/app/admin";
        return "/app";
    };
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={user ? <Navigate to={homeFor(user)} replace /> : <Login />} />
            <Route path="/register" element={user ? <Navigate to={homeFor(user)} replace /> : <Register />} />

            <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
                <Route index element={<Navigate to={user ? homeFor(user) : "/login"} replace />} />
                {/* Professional */}
                <Route path="opportunita" element={<Protected roles={["professional"]}><ProfessionalHome /></Protected>} />
                <Route path="salvate" element={<Protected roles={["professional"]}><ProfessionalSaved /></Protected>} />
                <Route path="candidature" element={<Protected roles={["professional"]}><ProfessionalApplications /></Protected>} />
                <Route path="profilo" element={<Protected roles={["professional"]}><ProfessionalProfile /></Protected>} />
                {/* Facility */}
                <Route path="annunci" element={<Protected roles={["facility"]}><FacilityHome /></Protected>} />
                <Route path="annunci/nuovo" element={<Protected roles={["facility"]}><FacilityJobs /></Protected>} />
                <Route path="candidature-ricevute" element={<Protected roles={["facility"]}><FacilityApplications /></Protected>} />
                <Route path="cerca-professionisti" element={<Protected roles={["facility"]}><FacilitySearch /></Protected>} />
                <Route path="statistiche" element={<Protected roles={["facility"]}><FacilityStats /></Protected>} />
                <Route path="struttura" element={<Protected roles={["facility"]}><FacilityProfile /></Protected>} />
                {/* Shared */}
                <Route path="job/:id" element={<Protected><JobDetail /></Protected>} />
                <Route path="chat" element={<Protected><Chat /></Protected>} />
                <Route path="chat/:id" element={<Protected><Chat /></Protected>} />
                <Route path="calendario" element={<Protected><Calendar /></Protected>} />
                {/* Admin */}
                <Route path="admin" element={<Protected roles={["admin"]}><AdminHome /></Protected>} />
                <Route path="admin/verifiche" element={<Protected roles={["admin"]}><AdminVerifications /></Protected>} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <AppRouter />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
